import search from "@domains/utils/search";
class FooterPresenter {
    constructor(useCases, actions) {
        this.useCases = useCases;
        this.actions = actions;
    }
    async getMarketStatus() {
        const footerData = await this.useCases.footer.getMarketStatus();
        return this.actions.footer.getMarketStatus(footerData);
    }
    updateShowMob_Menu(showFooter) {
        return this.actions.footer.updateShowMob_Menu(showFooter);
    }
    setShowFooterUi(showFooterUi) {
        return this.actions.footer.setShowFooterUi(showFooterUi);
    }
    getFooterPdfLinks() {
        return this.useCases.footer.getFooterPdfLinks();
    }
    getExchangeHolidays() {
        this.actions.staticFooter.exchangeHolidays.hideError();
        this.actions.staticFooter.exchangeHolidays.loader();
        this.useCases.staticFooter.exchangeHolidays.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.staticFooter.exchangeHolidays.getExchangeHolidayData(data);
                this.actions.staticFooter.exchangeHolidays.stopLoader();
            },
            onError: (error) => {
                this.actions.staticFooter.exchangeHolidays.setError({
                    isOpen: true,
                    error,
                });
                this.actions.staticFooter.exchangeHolidays.stopLoader();
            },
        }, null);
    }
    getCircularUpdates(req) {
        this.actions.staticFooter.circularUpdate.hideError();
        this.actions.staticFooter.circularUpdate.loader();
        this.useCases.staticFooter.circularUpdate.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.staticFooter.circularUpdate.getCircularUpdate(data);
                this.actions.staticFooter.circularUpdate.stopLoader();
            },
            onError: (error) => {
                this.actions.staticFooter.circularUpdate.setError({
                    isOpen: true,
                    error,
                });
                this.actions.staticFooter.circularUpdate.stopLoader();
            },
        }, req);
    }
    getlocationUpdates() {
        this.actions.staticFooter.location.hideError();
        this.actions.staticFooter.location.loader();
        this.useCases.staticFooter.locateus.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.staticFooter.location.getlocationData(data);
                this.actions.staticFooter.location.stopLoader();
            },
            onError: (error) => {
                this.actions.staticFooter.location.setError({
                    isOpen: true,
                    error,
                });
                this.actions.staticFooter.location.stopLoader();
            },
        }, null);
    }
    getFaqUpdates() {
        this.actions.staticFooter.faq.hideError();
        this.actions.staticFooter.faq.loader();
        this.useCases.staticFooter.faqlist.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.staticFooter.faq.getFaqData(data);
                this.actions.staticFooter.faq.stopLoader();
            },
            onError: (error) => {
                this.actions.staticFooter.faq.setError({
                    isOpen: true,
                    error,
                });
                this.actions.staticFooter.faq.stopLoader();
            },
        }, null);
    }
    getSearchedCircularData(data, searchData) {
        return search(data, "title", searchData);
    }
}
export default FooterPresenter;
